"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChanges = getChanges;
exports.omitDeep = omitDeep;
const lodash_1 = require("lodash");
function getChanges(original, modified, attrs) {
    if (!attrs) {
        attrs = Object.keys(modified);
    }
    const originalObj = (0, lodash_1.isNil)(original) ? {} : original;
    return attrs.reduce((acc, attrName) => {
        if ((0, lodash_1.isNil)(original) && (0, lodash_1.isNil)(modified)) {
            return acc;
        }
        if ((0, lodash_1.isNil)(originalObj[attrName]) && (0, lodash_1.isNil)(modified[attrName])) {
            return acc;
        }
        if (!(0, lodash_1.isEqual)(originalObj[attrName], modified[attrName])) {
            acc[attrName] = modified[attrName];
        }
        return acc;
    }, {});
}
function omitDeep(data, predicate) {
    if ((0, lodash_1.isArray)(data)) {
        return data.map((val) => omitDeep(val, predicate));
    }
    if (!(0, lodash_1.isObject)(data)) {
        return data;
    }
    return Object.keys(data).reduce((acc, key) => {
        const value = data[key];
        if ((0, lodash_1.isObject)(value) || (0, lodash_1.isArray)(value)) {
            acc[key] = omitDeep(value, predicate);
        }
        else if (!predicate(key, value)) {
            acc[key] = value;
        }
        return acc;
    }, {});
}
//# sourceMappingURL=obj.js.map